import { LinkedinLogo, EnvelopeSimple, Phone } from "@phosphor-icons/react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-slate-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <div className="mb-4">
              <img src="/invoquity-logo.png" alt="Invoquity" className="h-8 w-auto" />
            </div>
            <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
              Turn unpaid invoices into instant working capital. Currently onboarding founding customers.
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-4">Company</p>
            <ul className="space-y-2 text-sm text-slate-700">
              <li><a href="#solution" className="hover:text-emerald-800">About</a></li>
              <li><a href="#" className="hover:text-emerald-800">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-emerald-800">Terms</a></li>
              <li><a href="#early-access" className="hover:text-emerald-800">Contact</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-4">Reach us</p>
            <ul className="space-y-2 text-sm text-slate-700">
              <li className="flex items-center gap-2"><EnvelopeSimple size={16} /> hello@invoquity.com</li>
              <li className="flex items-center gap-2"><Phone size={16} /> +91 00000 00000</li>
              <li className="flex items-center gap-2"><LinkedinLogo size={16} /> <a href="#" className="hover:text-emerald-800">LinkedIn</a></li>
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-widest text-slate-500 mb-4">Status</p>
            <span className="inline-flex items-center rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800">
              <span className="w-1.5 h-1.5 rounded-full bg-emerald-700 mr-2 animate-pulse" />
              Launching Soon · Early Access Open
            </span>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-slate-200 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Invoquity. All rights reserved.</p>
          <p className="text-xs text-slate-500">Invoice financing platform · India</p>
        </div>
      </div>
    </footer>
  );
}
